import {
  SHOW_EMAIL_VERIFICATION_FORM_REQUEST,
  SHOW_EMAIL_VERIFICATION_FORM_FAILED,
  SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED,
  SEND_NEW_EMAIL_VERIFICATION_REQUEST,
  SEND_NEW_EMAIL_VERIFICATION_FAILED,
  SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED,
} from 'Redux/Types/EmailVerificationTypes'

const INITIAL_STATE = {
  sent: false,
  loading: false,
  clicked: false,
}

export default (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case SHOW_EMAIL_VERIFICATION_FORM_REQUEST:
      return { ...state, clicked: false, loading: true }
    case SHOW_EMAIL_VERIFICATION_FORM_FAILED:
      return { ...state, clicked: false, loading: false }
    case SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED:
      return { ...state, clicked: true, loading: false }

    case SEND_NEW_EMAIL_VERIFICATION_REQUEST:
      return { ...state, sent: false, loading: true }
    case SEND_NEW_EMAIL_VERIFICATION_FAILED:
      return { ...state, sent: false, loading: false }
    case SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED:
      return { ...state, sent: true, loading: false }
    default:
      return state
  }
}
